import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDividerModule} from '@angular/material/divider';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { PdfreporteComponent } from './pdfreporte.component';
import { ListaCTComponent } from '../../lista-ct.component';
import {MatListModule} from '@angular/material/list';
import { PdfMakeWrapper } from 'pdfmake-wrapper';
import * as pdfFonts from "pdfmake/build/vfs_fonts"; // fonts provided for pdfmake
// Set the fonts to use
PdfMakeWrapper.setFonts(pdfFonts);

// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';

// SERVICIO AUTORIZACION E INTERCEPTION DE TOKEN
import { AuthGuard } from 'app/auth/auth.guard';
// slug    : '/NOM35-ENC/wizard-enc/collaborators',

const rutas: Routes = [
    // trust index
    {
        path     : 'NOM35/reporte-ct/:fecha/:colaboradores/:id/:nombreCT/:empresaPadre',
        component: PdfreporteComponent,
        canActivate: [AuthGuard]
    }
];

@NgModule({
  declarations: [PdfreporteComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    FlexLayoutModule,
    MatProgressBarModule,
    TranslateModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatDividerModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatListModule
  ]
})
export class PdfReporteModule { }
